import type { NextPage } from "next";
import Head from "next/head";
import { useMemo } from "react";
import { PageProvider } from "@providers/page";

import Stake from "../container/pages/stake";
import { getStakeData } from "@services/gsheets";
import RightSidebar from "@components/RightSidebar";

import useLedgerCookies from "@hooks/useLedgerCookies";
import { Box, Grid } from "@chakra-ui/react";

export async function getStaticProps() {
  const [availableTags, tokenTagMapping] = await getStakeData();
  return { props: { availableTags, tokenTagMapping } };
}

interface PageProps extends Awaited<ReturnType<typeof getStaticProps>> {}

const Restake: NextPage<PageProps["props"]> = ({
  availableTags,
  tokenTagMapping,
}) => {
  const getHeader = useMemo(() => {
    return (
      <Head>
        {/* <title>Kelp</title>
        <meta name="description" content="Kelp" />
        <link rel="icon" href="/favicon.ico" /> */}
        <title>
          Liquid restaking | Restake ETH or LSTs, mint rsETH and earn Kernel
          Points!
        </title>
        <meta
          name="description"
          content="Unlock higher rewards and DeFi utility for restaked assets through liquid restaking with rsETH. Get dual rewards with EigenLayer Restaked Points and Kernel Points."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta property="og:image" content="/restake_preview_image.png" />
        <meta
          property="og:title"
          content=" Liquid restaking | Restake ETH or LSTs, mint rsETH and earn Kernel Points!"
        />
        <meta
          property="og:description"
          content="Unlock higher rewards and DeFi utility for restaked assets through liquid restaking with rsETH. Get dual rewards with EigenLayer Restaked Points and Kernel Points."
        />
      </Head>
    );
  }, []);

  useLedgerCookies();

  return (
    <PageProvider value={{ pageData: { availableTags, tokenTagMapping } }}>
      {getHeader}

      <Grid
        templateColumns={{ base: "1fr", xl: "1fr 280px" }}
        px={{ base: 0, md: 12 }}
        w="100%"
        pb="2rem"
      >
        <Stake />
        <Box justifySelf={{ base: "center", xl: "flex-end" }}>
          <RightSidebar />
        </Box>
      </Grid>
    </PageProvider>
  );
};

export default Restake;
